// v6 F10   — Detect FB/IG/Messenger in-app browsers.
// v6 F11.1 — Uitgebreide patronen (TikTok, Snapchat, Line, WeChat, Twitter)
//            zodat álle bekende in-app webviews opgevangen worden.
//
// Google OAuth weigert deze webviews (error: "disallowed_useragent" / 403).
// We detecteren ze op basis van userAgent en tonen een instructie i.p.v.
// een kapotte Inloggen-knop. Backend `/api/auth/start` doet identieke
// check server-side voor gedeelde diepe links die LoginScreen overslaan.
//
// Refs:
//   - Facebook in-app:  "FBAN", "FBAV", "FB_IAB", "FBIOS"
//   - Messenger iOS:    "FBAN/MessengerForiOS" (vangt onze FBAN-check al),
//                       "Messenger", "MessengerLite"
//   - Instagram:        "Instagram"
//   - LinkedIn:         "LinkedInApp"
//   - TikTok:           "TikTok", "musical_ly", "BytedanceWebview"
//   - Snapchat:         "Snapchat"
//   - Line:             "Line/"
//   - WeChat:           "MicroMessenger"
//   - Twitter / X:      "Twitter", "TwitterAndroid"

const IN_APP_TESTS = [
  ["facebook",  /FBAN|FBAV|FB_IAB|FBIOS/i],
  ["messenger", /Messenger|MessengerLite|MessengerForiOS/i],
  ["instagram", /Instagram/i],
  ["linkedin",  /LinkedInApp/i],
  ["tiktok",    /TikTok|musical_ly|BytedanceWebview/i],
  ["snapchat",  /Snapchat/i],
  ["line",      /Line\//i],
  ["wechat",    /MicroMessenger/i],
  ["twitter",   /Twitter|TwitterAndroid/i],
];

export function detectInAppBrowser(uaInput) {
  const ua = (uaInput
    ?? (typeof navigator !== "undefined" ? navigator.userAgent : ""))
    .toString();
  if (!ua) return null;
  // Volgorde maakt uit: Messenger-iOS UA bevat ook FBAN, maar het label
  // "messenger" sluit beter aan op wat de gebruiker ziet. Daarom checken
  // we Messenger expliciet vóór de generieke Facebook-match.
  if (/Messenger|MessengerLite|MessengerForiOS/i.test(ua)) return "messenger";
  for (const [label, rx] of IN_APP_TESTS) {
    if (label === "messenger") continue; // al gecheckt
    if (rx.test(ua)) return label;
  }
  return null;
}

export const IN_APP_LABEL = {
  facebook:  "Facebook",
  messenger: "Messenger",
  instagram: "Instagram",
  linkedin:  "LinkedIn",
  tiktok:    "TikTok",
  snapchat:  "Snapchat",
  line:      "Line",
  wechat:    "WeChat",
  twitter:   "Twitter / X",
};
